const base = '/events'

const routes = {
  root: base,
}

export default routes
